import { updateAlertMessage } from "../stores/useAlertStore";
import { updateErrorCode } from "../stores/useErrorCodeStore";

export const checkErrorType = (url: string, status: number) => {
  if (!navigator.onLine) {
    updateAlertMessage({
      type: "error",
      message: "인터넷 연결을 확인해 주세요.",
      timeout: 3000,
    });
    return;
  }

  if (status === 401 || status === 403) {
    updateErrorCode(401);
    return;
  }

  if (!url) return;
  const [_, apiType, endPoint] = url.split("/");

  if (status)
    switch (apiType) {
      case "user":
        if (endPoint === "login")
          updateAlertMessage({
            type: "error",
            message: "아이디 또는 비밀번호가 일치하지 않습니다.",
            timeout: 3000,
          });
        break;
      default:
        updateAlertMessage({
          type: "error",
          message: "예기치 못한 오류가 발생했습니다. 다시 시도해주세요.",
          timeout: 3000,
        });
    }
  else
    updateAlertMessage({
      type: "error",
      message: "예기치 못한 오류가 발생했습니다. 다시 시도해주세요.",
      timeout: 3000,
    });
};

export const returnData = () => {};
